export const favouriteConstants = {
     // shortlist candidate
  CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_REQUEST: "CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_REQUEST",
  CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_SUCCESS: "CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_SUCCESS",
  CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_FAILURE: "CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_FAILURE",

  // update shortlist candidate
  UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_REQUEST: "UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_REQUEST",
  UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_SUCCESS: "UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_SUCCESS",
  UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_FAILURE: "UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_FAILURE",

   // delete shorlist candidate
  DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_REQUEST: "DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_REQUEST",
  DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_SUCCESS: "DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_SUCCESS",
  DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_FAILURE: "DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_FAILURE",

  // get shortlist candidates by assignment kit
  GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_REQUEST:"GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_REQUEST",
  GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_SUCCESS:"GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_SUCCESS",
  GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_FAILURE:"GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_FAILURE",
  };
  